import { Component } from '@angular/core';

@Component({
  selector: 'nec-footer-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./copyright.component.scss']
})
export class NecPrivacyComponent {
}
